export default function Hero() {
  return (
    <header>
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/38d49c41ef58c55f7d4334e03218ca93.jpg"
            alt="Skip Hire Services in Johannesburg"
            title="S2K Waste Services - Professional Skip Hire"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <div className="mb-6 inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
            <i className="ri-checkbox-circle-fill text-green-400 text-lg"></i>
            <span className="text-white text-sm font-medium">Serving 500+ Projects Annually</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            <strong>Reliable Skip Hire</strong> &<br />
            <span className="text-orange-400"><strong>Waste Solutions</strong></span><br />
            Fast, Affordable, Hassle-Free
          </h1>

          <div className="mb-6 inline-flex items-center space-x-2 bg-orange-500/90 backdrop-blur-sm px-5 py-3 rounded-full">
            <i className="ri-truck-line text-white text-xl"></i>
            <span className="text-white text-base font-semibold">Mini Skip 2 & 3 Ton Bins Available</span>
          </div>

          <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed">
            From residential clean-ups to large-scale commercial projects, <strong>S2K Waste Services</strong> delivers skips when and where you need them in <strong>Kwa Zulu Natal</strong>.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/27844606965"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-orange-500 text-white text-base font-bold rounded-full hover:bg-orange-600 transition-all hover:-translate-y-1 shadow-lg cursor-pointer whitespace-nowrap"
            >
              Get a Quote
            </a>
            <a
              href="https://wa.me/27844606965"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-bold rounded-full hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
            >
              Book a Skip Now
            </a>
          </div>

          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
            <i className="ri-arrow-down-line text-white text-3xl"></i>
          </div>
        </div>
      </section>
    </header>
  );
}